/**
 * Single source of truth for API base URL.
 * In production we always use '' (same-origin /api/*) for root deployment (e.g. novabotx.com).
 * No env or pathname checks - production = root API only.
 */
export function getApiBaseUrl() {
  if (import.meta.env.PROD) return '';
  // In dev, use same-origin requests so Vite proxies /api to the backend.
  if (import.meta.env.DEV) return '';
  return (
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_API_URL?.replace('/api/rag/answer', '') ||
    'http://localhost:3000'
  );
}
